import { PermissionKey } from "@fitness-app/data-models";

import { usePermission } from "~/hooks/usePermission";
import { usePostHogFeatureFlag } from "~/hooks/usePostHogFeatureFlag";

export const TRAINER_ASSISTANT_FEATURE_FLAG = "trainer_assistant_feature";

/**
 * TRE-2313 — asystent jest dla ról trenerskich (trener, head coach, właściciel konta,
 * administracja). Bramka po uprawnieniach, nie po roli: ten sam zestaw co endpoint
 * i RLS (`agent_chat_can_use('trainer_assistant')`) - agents.use + clients.read +
 * chat.read. Sprzedaż i support nie mają chat.read, więc bubble się im nie pokazuje.
 */
export const useTrainerAssistantEnabled = () => {
  const canUseAgents = usePermission(PermissionKey.AGENTS_USE);
  const canReadClients = usePermission(PermissionKey.CLIENTS_READ);
  const canReadChat = usePermission(PermissionKey.CHAT_READ);
  const { enabled } = usePostHogFeatureFlag(TRAINER_ASSISTANT_FEATURE_FLAG);

  return enabled && canUseAgents && canReadClients && canReadChat;
};
